export default {
  errors: null,
  users: [],
  loading: false,
  count: 0,
  totalCount: 0
};
